// The next seed should be 87 (then 90, ... 3n)

import { AB_10_90, AB_20_80, AB_25_75, AB_50_50, AB_5_95, AB_90_10 } from './ABTestUtils'

export function turnStringToSeed(target: string) {
	let hash = 0
	for (let i = 0; i < target.length; i++) {
		const character = target.charCodeAt(i)
		hash = ((hash << 5) - hash) + character
		hash = hash & hash
	}

	return Math.abs((Math.floor(hash / 3))) * 3
}

export class CasinoGameABExperiment {
	private readonly percent

	constructor(a: 5 | 10 | 20 | 25 | 50 | 90, seed: number) {
		switch (a) {
		case 5:
			this.percent = AB_5_95(seed)
			break
		case 10:
			this.percent = AB_10_90(seed)
			break
		case 20:
			this.percent = AB_20_80(seed)
			break
		case 25:
			this.percent = AB_25_75(seed)
			break
		case 50:
			this.percent = AB_50_50(seed)
			break
		case 90:
			this.percent = AB_90_10(seed)
			break
		}
	}

	get isGroupA() {
		return this.percent[0](globalMyPlayer.id)
	}
	get isGroupB() {
		return this.percent[1](globalMyPlayer.id)
	}
}

class PokerOnlyDowntimeExperiment {
	private readonly canaryPercent = AB_50_50(60)

	// Active group; uses Poker Only Downtime flow.
	// TODO: Delete Feature toggle for Poker Only Downtime
	isGroupA() {
		return true
	}

	// Control group; uses current Downtime flow.
	isGroupB() {
		return this.canaryPercent[1](globalMyPlayer.id)
	}
}

class BankDetailsVerificationExperiment {
	private readonly canaryPercent = AB_25_75(63)

	// Active group; redirect to Bank Details Verification flow.
	isGroupA(userId: number) {
		return this.canaryPercent[0](userId)
	}

	// Control group; send to existing flow.
	isGroupB(userId: number) {
		return this.canaryPercent[1](userId)
	}
}

class MobileBannerExperiment {
	private readonly canaryPercent = AB_50_50(66)

	// Active group; uses new daily bonus animation section.
	isGroupA(userId: number) {
		return this.canaryPercent[0](userId)
	}

	// Control group; send to existing flow.
	isGroupB(userId: number) {
		return this.canaryPercent[1](userId)
	}
}

class ReactGameTabsExperiment {
	private readonly canaryPercent = AB_20_80(84)

	// Active group;
	isGroupA(userId: number) {
		return this.canaryPercent[0](userId)
	}

	// Control group;
	isGroupB(userId: number) {
		return this.canaryPercent[1](userId)
	}
}

class JsngLobbyRedesignExperiment {
	private readonly canaryPercent = AB_50_50(42)

	// Active group; uses new daily bonus animation section.
	isGroupA(userId: number) {
		return this.canaryPercent[0](userId)
	}

	// Control group; send to existing flow.
	isGroupB(userId: number) {
		return this.canaryPercent[1](userId)
	}
}

export const ABExperimentService = new class {
	seaRadiers = new CasinoGameABExperiment(50, turnStringToSeed('sea raiders'))
	pokerOnlyDowntime = new PokerOnlyDowntimeExperiment()
	bankDetailsVerification = new BankDetailsVerificationExperiment()
	mobileBannerExperimentSection = new MobileBannerExperiment()
	reactGameTabsExperiment = new ReactGameTabsExperiment()
	jsngLobbyRedesignExperiment = new JsngLobbyRedesignExperiment()
}()
